import { useState, useEffect } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { SearchContext } from "../hooks/useSearch";

export const SearchProvider = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // Đồng bộ searchQuery với URL params khi page thay đổi
  useEffect(() => {
    const currentSearch = searchParams.get("search") || "";
    setSearchQuery(currentSearch);
  }, [searchParams]);

  const handleSearch = (query) => {
    const trimmedQuery = query.trim();
    setSearchQuery(trimmedQuery);

    // Tạo URL params mới
    const newParams = new URLSearchParams();

    // Nếu có query thì thêm vào params
    if (trimmedQuery) {
      newParams.set("search", trimmedQuery);
    }

    // Reset page về 1 khi search
    newParams.set("page", "1");

    // Giữ lại các params khác nếu đang ở trang schools
    if (location.pathname === "/schools") {
      const currentLevel = searchParams.get("level");
      if (currentLevel) {
        newParams.set("level", currentLevel);
      }

      // Cập nhật URL mà không navigate
      const newUrl = `/schools?${newParams.toString()}`;
      window.history.replaceState(null, "", newUrl);
    } else {
      // Nếu không ở trang schools thì navigate tới đó
      navigate(`/schools?${newParams.toString()}`);
    }
  };

  const clearSearch = () => {
    setSearchQuery("");

    if (location.pathname === "/schools") {
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("search");
      newParams.set("page", "1");

      const newUrl = `/schools?${newParams.toString()}`;
      window.history.replaceState(null, "", newUrl);
    }
  };

  const value = {
    searchQuery,
    setSearchQuery,
    handleSearch,
    clearSearch,
  };

  return (
    <SearchContext.Provider value={value}>{children}</SearchContext.Provider>
  );
};
